<template>
  
  <div class="home">
    <ExitIntentPopup @accepted="onPopupAccepted"/>
    <!-- <div class="countdown">
      <b-container>
        <b-row class="align-items-center">
          <b-col md="6" class="align-items-center">
            <p class="title">¡ÚNETE A ACTOR'S CHALLENGE!</p>
          </b-col>
          <b-col md="6" sm="12" class="align-items-center">
            <div class="row pl-2 pr-2 mr-0 ml-0 count align-items-center">
              <a href="#compra" class="btn">
                INICIO EN:
              </a>
              <VueCountdown :time="time" v-slot="{ days, hours, minutes, seconds }">
                <div class="row pl-2 pr-2 mr-0 ml-0"> 
                  <p><span>{{ days }}</span><br/> DÍAS</p> <span class="separation">:</span> <p><span>{{ hours }}</span><br/> HRS</p> <span class="separation">:</span> <p><span>{{ minutes }}</span><br/> MIN</p> <span class="separation">:</span> <p><span>{{ seconds }}</span><br/> SEG</p>
                </div>
              </VueCountdown>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div> -->
    <!-- <b-navbar toggleable="lg" type="dark" >
      <img class="img-fluid logopeak" src="../assets/img/logo.svg" alt="">
      <img class="img-fluid logoac" src="../assets/img/aclogo.svg" alt="">
    </b-navbar> -->
    <!-- <b-container fluid class="banner">
      <b-row class="align-items-center">

      </b-row>
    </b-container> -->
    <!-- <b-container fluid class="sectionvideo">
      <b-row class="align-items-center">
        <b-col lg="5" class="align-items-center">
          

        </b-col>
      </b-row>
    </b-container> -->
    <b-container id="curso" fluid class="section2">
      <b-row>
        <b-col class="mb-4" lg="5">
          <img class="img-fluid mb-5 mobile-logo" src="../assets/img/Logo_ActorsChallenge-21.svg" alt="">
          <video 
              autoplay 
              muted 
              loop 
              controls
              playsinline
          >
              <source src="../assets/img/ACH_INVITADOS_2_NF_.mp4" type="video/mp4">
              Tu navegador no soporta la reproducción de video.
          </video>
          <!--  -->
          <!-- <img class="img-fluid" src="../assets/img/aci.png" alt="">           -->
        </b-col>
        <b-col class="mb-4" lg="7">
          <img class="img-fluid mb-5 desktop-logo" src="../assets/img/Logo_ActorsChallenge-21.svg" alt="">
          <div class="mb-4 blue-wrapper">
            <p class="mb-0">Un actor talentoso sin estrategia y ruta, <b>SE PIERDE.</b></p>
          </div>
          <p class="mb-4 text-center" style="text-transform: uppercase; "><b>Deja de buscar oportunidades. <br>Haz que la industria te busque a ti.</b></p>
          <p class="mb-4 green-wrapper day" style="text-transform: uppercase;">Programa de <b>4 días</b> completamente en línea y en vivo.</p>
          <p class="text1">Diseñado para que los actores conozcan el mapa correcto para ser visibles a directores y directores de casting, y acercarse a ser parte de las series y películas hispanohablantes.</p>
          <p class="text2"><img class="img-fluid" src="../assets/img/NUM.svg" alt="">   No promete fama. No vende fantasías.</p>
          <b-row class="mt-4">
            <b-col class="mb-4" md="4">
                <div class="green-wrapper">
                  <b class="num">+1500</b><br>
                  <span style="color: #737070; font-weight: 700;">Actores Formados</span>
                </div>
            </b-col>
            <b-col class="mb-4" md="8">
              <p><b>Únete a los más de 1500 actores que ya han pasado por Actor's Challenge.</b></p>
            </b-col>
          </b-row>
          <a href="#compra" class="btn">Asegura tu lugar para el 16 de marzo</a>
        </b-col>
      </b-row>
    </b-container>
    <b-container fluid class="sectionaparaquienes">
      <b-row class="">
        <b-col lg="12">
          <h3 class="mb-4"><img class="img-fluid" src="../assets/img/sectionaparaquienes.svg"></h3>
        </b-col>
        <b-col lg="6" class="mb-4">
          <div class="quines-wrapper">
            <p class="subtitle"><b>Esto es para ti si… </b></p>
            <p class="bullet"><img class="img-fluid" src="../assets/img/bulletgreen.svg"> Te sientes con talento, pero sin ruta y técnicas para lograr hacer castings o ser contratado como actor.</p>
            <p class="bullet"><img class="img-fluid" src="../assets/img/bulletgreen.svg"> Quieres saber qué materiales y estrategia necesitas para ser llamadx a casting.</p>
            <p class="bullet"><img class="img-fluid" src="../assets/img/bulletgreen.svg"> Buscas estructura con conocimiento para dejar de improvisar y tomar acciones con claridad y resultados.</p>
          </div>
        </b-col>
        <b-col lg="6" class="mb-4">
          <div class="quines-wrapper">
          <p class="subtitle"><b>Esto NO es para ti si…  </b></p>
          <p class="bullet"><img class="img-fluid" src="../assets/img/bulletred.svg"> Estás buscando “fama rápida” o una promesa mágica.</p>
          <p class="bullet"><img class="img-fluid" src="../assets/img/bulletred.svg"> No estás dispuestx a aplicar un proceso y trabajar tu estrategia con disciplina.</p>
          </div>
        </b-col>
        <b-col lg="12" class="mb-4 text-center">
          <a href="#compra" class="btn">Asegura tu lugar para el 16 de marzo</a>
        </b-col>
      </b-row>
    </b-container>
    <b-container id="temario" fluid class="sectioncurso">
      <b-row>
        <b-col lg="12" class="text-center mb-5">
          <img class="img-fluid" src="../assets/img/Logo_ActorsChallenge-31.svg" alt="">
        </b-col>
        <b-col lg="12" class="text-center mb-5">
          <h3 class="mb-4"><img style="width: 600px;" class="img-fluid" src="../assets/img/CALENDARIO.svg"></h3>
        </b-col>
        <b-col lg="12" class="mb-5">
          <div class="wrappercurso-purple">
            <p class="titleday">Día 1: Autenticidad — descubre lo que te hace únicx y atractivx frente a un director</p>
            <ul>
              <li><b>Fecha:</b> Lunes 16 de marzo 2026</li>
              <li><b>Horario:</b> 07:30 PM (hora CDMX)</li>
              <li><b>Transformación:</b> Descubre qué te hace únicx y atractivx frente a un director.</li>
              <li><b>Exponente:</b> Alejandro Lozano</li>
            </ul>
          </div>
        </b-col>
        <b-col lg="12" class="mb-5">
          <div class="wrappercurso-black">
            <p class="titleday">Día 2: Aprendizaje y entrenamiento para audicionar continuamente</p>
            <ul>
              <li><b>Fecha:</b> Martes 17 de marzo 2026</li>
              <li><b>Horario:</b> 07:30 PM (hora CDMX</li>
              <li><b>Transformación:</b> Técnicas de preparación, entrenamiento y construcción de personaje para lograr más audiciones.</li>
              <li><b>Exponente:</b> Juan Ignacio Pucci</li>
            </ul>
          </div>
        </b-col>
        <b-col lg="12" class="mb-5">
          <div class="wrappercurso-purple">
            <p class="titleday">Día 3: El actor como producto y marca personal</p>
            <ul>
              <li><b>Fecha:</b> Miércoles 18 de marzo 2026</li>
              <li><b>Horario:</b> 07:30 PM (hora CDMX)</li>
              <li><b>Transformación:</b> Marca personal , todo lo que esto abarca y cómo influye  en los tomadores de decisiones.</li>
              <li><b>Exponente:</b> Rodrigo Santos</li>
            </ul>
          </div>
        </b-col>
        <b-col lg="12" class="mb-5">
          <div class="wrappercurso-black">
            <p class="titleday">Día 4: La industria del entretenimiento y cómo pertenecer a ella</p>
            <ul>
              <li><b>Fecha:</b> Jueves 19 de marzo 2026</li>
              <li><b>Horario:</b> 07:30 PM (hora CDMX)</li>
              <li><b>Transformación:</b> Entiende el contexto global del entretenimiento, sus jugadores estratégicos y cómo debe abordarlo estratégicamente el actor para hacerse parte.</li>
              <li><b>Exponente:</b>  Fernando Sariñana</li>
            </ul>
          </div>
        </b-col>
        <b-col lg="12" class="text-center mb-5">
          <a href="#compra" class="btn">Asegura tu lugar para el 16 de marzo</a>
        </b-col>
      </b-row>
    </b-container>
    <b-container fluid class="sectionaccesos">
      <b-row>
        <b-col lg="12" class="text-center mb-4">
          <h2 class="mb-4">ACCESOS</h2>
          <p class="mb-0"><b>Hemos preparado 3 modalidades para Actor's Challenge</b></p>
          <p class="mb-0">Incluye acceso completo, material exclusivo y sesión especial en vivo para alumnos.</p>
          <p><b>Precio de lanzamiento. Cupo limitado.</b></p>
        </b-col>
        <b-col lg="12" class="text-center mb-4">
          <table class="table">
            <thead>
              <tr>
                <th class="mobile-cell" scope="col"></th>
                <th scope="col">¿QUÉ INCLUYE?</th>
                <th scope="col">WELCOME<br>$29.99 USD <br><span>$517 MXN</span></th>
                <th scope="col">PRO<br>$69.99 USD <br><span>$1,208.32 MXN </span></th>
                <th scope="col">PEAKER<br>$89.99 USD <br><span>$1,553.61 MXN </span></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="mobile-cell" scope="row">1</td>
                <td style="text-align: left">Acceso al programa (4 días) Exponentes</td>
                <td> <img class="img-fluid" src="../assets/img/r.svg"> </td>
                <td> <img class="img-fluid" src="../assets/img/r.svg"> </td>
                <td> <img class="img-fluid" src="../assets/img/r.svg"> </td>
              </tr>
              <tr>
                <td class="mobile-cell" scope="row">2</td>
                <td style="text-align: left">Workbooks diarios</td>
                <td> <img class="img-fluid" src="../assets/img/r.svg"> </td>
                <td> <img class="img-fluid" src="../assets/img/r.svg"> </td>
                <td> <img class="img-fluid" src="../assets/img/r.svg"> </td>
              </tr>
              <tr>
                <td class="mobile-cell" scope="row">3</td>
                <td style="text-align: left">Retos y dinámicas</td>
                <td> <img class="img-fluid" src="../assets/img/r.svg"> </td>
                <td> <img class="img-fluid" src="../assets/img/r.svg"> </td>
                <td> <img class="img-fluid" src="../assets/img/r.svg"> </td>
              </tr>
              <tr>
                <td class="mobile-cell" scope="row">4</td>
                <td style="text-align: left">Acceso a comunidad</td>
                <td> <img class="img-fluid" src="../assets/img/r.svg"> </td>
                <td> <img class="img-fluid" src="../assets/img/r.svg"> </td>
                <td> <img class="img-fluid" src="../assets/img/r.svg"> </td>
              </tr>
              <tr>
                <td class="mobile-cell" scope="row">5</td>
                <td style="text-align: left">Participación en premios</td>
                <td> <img class="img-fluid" src="../assets/img/r.svg"> </td>
                <td> <img class="img-fluid" src="../assets/img/r.svg"> </td>
                <td> <img class="img-fluid" src="../assets/img/r.svg"> </td>
              </tr>
              <tr>
                <td class="mobile-cell" scope="row">6</td>
                <td style="text-align: left">Certificado de terminación</td>
                <td> <img class="img-fluid" src="../assets/img/r.svg"> </td>
                <td> <img class="img-fluid" src="../assets/img/r.svg"> </td>
                <td> <img class="img-fluid" src="../assets/img/r.svg"> </td>
              </tr>
              <tr>
                <td class="mobile-cell" scope="row">7</td>
                <td style="text-align: left">Webinar de preguntas y respuestas con cada exponente del día</td>
                <td>  </td>
                <td> <img class="img-fluid" src="../assets/img/r.svg"> </td>
                <td> <img class="img-fluid" src="../assets/img/r.svg"> </td>
              </tr>
              <tr>
                <td class="mobile-cell" scope="row">8</td>
                <td style="text-align: left">Workbook de Redes Sociales para actores</td>
                <td> </td>
                <td> </td>
                <td> <img class="img-fluid" src="../assets/img/r.svg"> </td>
              </tr>
              <tr>
                <td class="mobile-cell" scope="row">9</td>
                <td style="text-align: left">Template de CV para actores</td>
                <td> </td>
                <td> </td>
                <td> <img class="img-fluid" src="../assets/img/r.svg"> </td>
              </tr>
              <tr>
                <td class="mobile-cell" scope="row">10</td>
                <td style="text-align: left">Q&A con Michelle Morán y Emilie Morán (30 min, cada día)</td>
                <td> </td>
                <td> </td>
                <td> <img class="img-fluid" src="../assets/img/r.svg"> </td>
              </tr>
              <tr>
                <td class="mobile-cell" scope="row">11</td>
                <td style="text-align: left; font-size: large;"><b>Descuento en asesoría</b></td>
                <td>  </td>
                <td>  </td>
                <td> <label>50%</label> </td>
              </tr>
              <tr>
                <td class="mobile-cell" scope="row"></td>
                <td style="text-align: left">Acceso a grabaciones por 30 días (todos los planes)</td>
                <td> <img class="img-fluid" src="../assets/img/r.svg"> </td>
                <td> <img class="img-fluid" src="../assets/img/r.svg"> </td>
                <td> <img class="img-fluid" src="../assets/img/r.svg"> </td>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
    </b-container>
    <b-container id="compra" fluid class="sectioncompras">
      <b-row>
        <b-col class="mb-4" lg="4">
          <div class="cardbuy welcome">
            <p class="title">Welcome</p>
            <hr>
            <p class="nameplan">Plan básico</p>
            <p class="price">$29.99 USD<br>/<span>$517 MXN</span></p>
            <div class="inner">
              <p class="bullets"><img src="../assets/img/check.svg" alt=""> Cursos los 4 días en vivo </p>
              <p class="bullets"><img src="../assets/img/check.svg" alt=""> Workbooks diarios + retos </p>
              <p class="bullets"><img src="../assets/img/check.svg" alt=""> Comunidad + premios + certificado </p>
              <p class="bullets"><img src="../assets/img/check.svg" alt=""> Grabaciones 30 días </p>
            </div>
            <a href="https://buy.stripe.com/8x2bJ3akf83a8ZFe167ok1H?prefilled_promo_code=40WELCOME" target="_blank" class="btn">Elegir WELCOME</a>
          </div>
        </b-col>
        <b-col class="mb-4" lg="4">
          <div class="cardbuy pro">
            <p class="title">Pro</p>
            <hr>
            <p class="nameplan">Plan Plus</p>
            <p class="price">$69.99 USD<br>/<span>$1,208.32 MXN</span></p>
            <div class="inner">
              <p class="mb-0">Todo lo de Welcome +</p>
              <p class="bullets"><img src="../assets/img/check.svg" alt=""> <b>Webinar Q&A con el exponente de cada día</b> (Alejandro / Juan Ignacio / Rodrigo / Fernando) </p>
            </div>
            <a href="https://buy.stripe.com/bJe4gB8c7abi7VB0ag7ok1I" target="_blank" class="btn">Elegir PRO</a>
          </div>
        </b-col>
        <b-col class="mb-4" lg="4">
          <div class="cardbuy peaker">
            <p class="title">Peaker</p>
            <hr>
            <p class="nameplan">Plan Premium</p>
            <p class="price">$89.99 USD<br>/<span>$1,553.61 MXN</span></p>
            <div class="inner">
              <p class="mb-0">Todo lo de Pro +</p>
              <p class="bullets"><img src="../assets/img/check.svg" alt=""> Workbook Redes Sociales para actores</p>
              <p class="bullets"><img src="../assets/img/check.svg" alt=""> Template CV para actores</p>
              <p class="bullets"><img src="../assets/img/check.svg" alt=""> <b>Q&A extra 30 min cada día con Michelle Morán y Emilie Morán</b> </p>
              <p class="bullets"><img src="../assets/img/check.svg" alt=""> <b>50% de descuento en asesoría</b> (Peak Network)</p>
            </div>
            <a href="https://buy.stripe.com/aFa9AV2RNabigs70ag7ok1J" target="_blank" class="btn">Elegir PEAKER</a>
          </div>
        </b-col>
        <!-- <b-col lg="12" class="text-center mb-5">
          <div class="wrapperdate">
            Curso desde el 16 al 19 de marzo
          </div>
        </b-col> -->
        <b-col lg="12" class="text-center mb-5">
          <a href="#compra" class="btn">Asegura tu lugar para el 16 de marzo</a>
        </b-col>
      </b-row>
    </b-container>
    <!-- <b-container class="sectionaprenderastitle">
      <b-row class="mt-5">
        <b-col lg="12" class="text-center mt-5">
          <h3><img class="img-fluid" src="../assets/img/queaprenderas.svg"></h3>
        </b-col>
      </b-row>
    </b-container> -->
    <!-- <b-container fluid class="sectionaprenderas">
      <b-row>
        <b-col lg="12">
          <div class="pleca2 mb-3 align-items-center">
            <p class="mb-0">Cómo iniciar una carrera actoral paso a paso.</p>
          </div>
          <div class="pleca1 mb-3 align-items-center">
            <p class="mb-0">Qué sí y qué no hacer al empezar.</p>
          </div>
          <div class="pleca2 mb-3 align-items-center">
            <p class="mb-0">Cómo prepararte para castings con intención.</p>
          </div>
          <div class="pleca1 mb-3 align-items-center">
            <p class="mb-0">Cómo pensar tu carrera a largo plazo.</p>
          </div>
          <div class="pleca2 mb-3 align-items-center">
            <p class="mb-0">Cómo dejar de improvisar.</p>
          </div>
        </b-col>
      </b-row>
    </b-container> -->
    
    <b-container id="invitados" fluid class="sectioninvitados">
      <b-row>
        <b-col lg="12" class="text-center mb-5">
          <h2>PANEL DE EXPERTOS</h2>
        </b-col>
        <b-col lg="12" class="text-center">
          <h4><b>Aprende de quienes crean y deciden</b></h4>
          <p class="mb-4">Durante 4 días escucharás la ruta explicada por profesionales con décadas dentro de la industria y el streaming.</p>
          <h4><b>Garantía de Autoridad:</b></h4>
          <p><b>Aprende de quienes realmente contratan. No son coaches, son líderes de la industria actual.</b></p>
        </b-col>
        <b-col lg="6" class="mb-5">
          <div class="text-center mb-5">
            <img class="img-fluid img-face" src="../assets/img/michelle.png" alt="">
            <img  class="img-fluid mb-4 img-name" src="../assets/img/michelle-name.png" alt="">
          </div>
          <p>Ha impulsado las carreras de cientos de actores a través de sus agencias de representación y es experta en estrategia y desarrollo de talento.</p>   
        </b-col>
        <b-col lg="6" class="mb-5">
          <div class="text-center mb-5">
            <img class="img-fluid img-face mt-2" src="../assets/img/emilie.png" alt="">
            <img  class="img-fluid mb-4 img-name" src="../assets/img/emilie-name.png" alt="">
          </div>
          <p>Directora de casting con más de 20 años de crear repartos en las series, películas y contenidos como "Contraataque", "Acapulco", "Amor de Oficina", "Control Z", etc. de los productores y plataformas más exitosos del mercado.</p>
        </b-col>
        <b-col lg="6" class="mb-5">
          <div class="text-center mb-5">
            <img class="img-fluid img-face mt-3" src="../assets/img/Fernando.png" alt="">
            <img class="img-fluid mb-5 img-name" src="../assets/img/FernandoSarinana.png" alt="">
          </div>
          <p><i>—showrunner / director.</i> Creador de éxitos como “Amor de Oficina”, “Madre solo hay dos”, “Amar te duele” entre muchos otros.</p>
        </b-col>
        <b-col lg="6" class="mb-5">
          <div class="text-center">
            <img class="img-fluid img-face" src="../assets/img/Rodrigo.png" alt="">
            <img class="img-fluid mb-4 img-name" src="../assets/img/RodrigoSantos.png" alt="">
            <a href="https://www.instagram.com/espantos" target="_blank"><img class="img-fluid mb-4 img-handle" src="../assets/img/@espantos.png" alt=""></a>
          </div>
          <p><i>— escritor / director / productor / showrunner </i>de producciones icónicas como “Chespirito”, “Belascoarán”, “Diablo Guardián” y “Colosio” entre otros.</p>
        </b-col>
        <b-col lg="6" class="mb-5">
          <div class="text-center">
            <img class="img-fluid img-face" src="../assets/img/Juan.png" alt="">
            <img class="img-fluid mb-3 img-name" src="../assets/img/JuanIgnacioPucci.png" alt="">
            <a href="https://www.instagram.com/acting__tips" target="_blank">(<img class="img-fluid mb-4 img-handle" src="../assets/img/acting__tips.svg" alt="">)</a>
          </div>
          <p><i>— creador de “Acting Tips”</i>, la comunidad digital de actores hispanos más influyente. Actor y coach con más de 20 años de trayectoria.</p>
        </b-col>
        <b-col lg="6" class="mb-5">
          <div class="text-center">
            <img class="img-fluid img-face" src="../assets/img/Alejandro.png" alt="">
            <img class="img-fluid mb-4 img-name" src="../assets/img/AlejandroLozano.png" alt="">
            <a href="https://www.instagram.com/patas" target="_blank"><img class="img-fluid mb-4 img-handle" src="../assets/img/@patas.png" alt=""></a>
          </div>
          <p><i>— director / creador / showrunner</i> de “Matando Cabos”, “Control Z” y “Sr. Ávila”. Redefine el thriller político con el próximo gran estreno original de Netflix: “El círculo”.</p>
        </b-col>
      </b-row>
    </b-container>

    <b-container id="testimonios" fluid class="sectiontestimonios">
      <b-row class="align-items-center">
        <b-col lg="12" class="text-center mb-5 mobile">
          <h3>TESTIMONIOS</h3>
        </b-col>
        <b-col lg="5" class="align-items-center mb-4">
          <video 
              autoplay 
              muted 
              loop 
              controls
              playsinline
          >
              <source src="../assets/img/ACH_TESTIMONIOS_LANDING.mp4" type="video/mp4">
              Tu navegador no soporta la reproducción de video.
          </video>

        </b-col>
        <b-col lg="7" class="align-items-center">
          <h3 class="desktop mb-5">TESTIMONIOS</h3>
          <VueSlickCarousel class="mb-5" v-bind="slickOptions">
            <div class="pl-1 pr-1" style="height: 100%">
              <div class="testimoniowrapper">
                <p class="quote">“Aprendí a no sucumbir al rechazo y a confiar en quien soy. Estar conectada y acompañada hace toda la diferencia.”</p>
                <p class="name">-Lorena Peña</p>
                <a href="https://www.instagram.com/bailalors" target="_blank" class="user">@bailalors</a>
              </div>
            </div>
          
            <div class="pl-1 pr-1" style="height: 100%">
              <div class="testimoniowrapper">
                <p class="quote">“Actors Challenge me ayudó a abrazarme, a ser yo y a entender que crecer como actor también es mirar hacia adentro, no solo a la industria.”</p>
                <p class="name">-Paolo Arámbula</p>
                <a href="https://www.instagram.com/paoloarambula" target="_blank" class="user">@paoloarambula</a>
              </div>
            </div>
            <div class="pl-1 pr-1" style="height: 100%">
              <div class="testimoniowrapper">
                <p class="quote">“Entendí que no tengo que actuar algo que no soy, sino vivirlo desde mi esencia. Son cambios pequeños, pero muy poderosos.”</p>
                <p class="name">-Patricia Maldoni</p>
                <a href="https://www.instagram.com/patriciamaldoni" target="_blank" class="user">@patriciamaldoni</a>
              </div>
            </div>
          </VueSlickCarousel>
          <div class="text-center pt-5">
            <a href="#compra" class="mb-5 btn">Asegura tu lugar para el 16 de marzo</a>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <b-container fluid class="sectionfaq">
      <b-row class="align-items-center">
        <b-col class="mb-4" lg="12">
          <h3>FAQ</h3>
        </b-col>
        <b-col class="mb-4 align-items-center" lg="6">

          <div class="accordion" role="tablist">
            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-1 class="btn-collapse">¿Cualquiera puede tomar el curso? <img src="../assets/img/v.png"  alt="icon arrow"/></b-button>
              </b-card-header>
              <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <b-card-text>Sí. Actors Challenge está diseñado no importa si estás dando tus primeros pasos, si ya tienes estudios en actuación o si llevas tiempo intentando ingresar a la industria. El curso está pensado precisamente para quienes se sienten desorientados y buscan claridad sobre cómo funciona el camino profesional del actor. Por lo tanto, no se requiere experiencia previa ni tener contactos.</b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-2 class="btn-collapse">¿Es en línea? <img src="../assets/img/v.png"  alt="icon arrow"/></b-button>
              </b-card-header>
              <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <b-card-text>Sí. El curso es completamente en línea y se imparte en vivo. Esto te permite participar en las sesiones, retos y dinámicas con la comunidad sin importar tu ubicación.</b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-3 class="btn-collapse">¿Cuánto dura y a qué hora es? <img src="../assets/img/v.png"  alt="icon arrow"/></b-button>
              </b-card-header>
              <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <b-card-text>Son 4 sesiones consecutivas, una por día. Cada sesión dura aprox. <b>60 minutos</b> y es a las <b>07:30 PM (hora CDMX)</b>.</b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-4 class="btn-collapse" >¿Queda grabado? <img src="../assets/img/v.png"  alt="icon arrow"/></b-button>
              </b-card-header>
              <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <b-card-text>Sí. El programa Actor's Challenge queda grabado íntegramente en nuestra plataforma exclusiva. Tendrás acceso a las sesiones durante <b>30 días posteriores</b> al evento para revivirlas, estudiar las técnicas y tomar notas a tu ritmo.</b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-5 class="btn-collapse" >¿El Q&A con invitado es con cada invitado o con ustedes? <img src="../assets/img/v.png"  alt="icon arrow"/></b-button>
              </b-card-header>
              <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <b-card-text>Es con <b>cada exponente especial</b>. Los participantes de los planes <b>PRO</b> y <b>PEAKER</b> tienen acceso a un webinar de preguntas y respuestas directamente con el ponente de cada jornada.</b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-6 class="btn-collapse" >¿Qué incluye peaker adicional? <img src="../assets/img/v.png"  alt="icon arrow"/></b-button>
              </b-card-header>
              <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <b-card-text>Solo los <b>PEAKER</b> se quedan <b>30 minutos extra cada día</b> en Q&A con <b>Emilie Morán y Michelle Morán</b>.</b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-7 class="btn-collapse" >¿Qué métodos de pago aceptan? <img src="../assets/img/v.png"  alt="icon arrow"/></b-button>
              </b-card-header>
              <b-collapse id="accordion-7" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <b-card-text>Puedes pagar con Tarjeta de Crédito, Débito, Apple Pay, Google Pay, Klarna, Afterpay, PayPal y Transferencia Bancaria.</b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-8 class="btn-collapse" >¿Cuentan con reembolso? <img src="../assets/img/v.png"  alt="icon arrow"/></b-button>
              </b-card-header>
              <b-collapse id="accordion-8" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <b-card-text>
                      <p>Queremos que te sientas seguro con tu inversión</p>
                      <ul>
                        <li>Hasta 7 días antes: Reembolso del 80%</li>
                        <li>De 6 a 2 días antes: Reembolso del 50%</li>
                        <li>Menos de 48 horas: No hay reembolso económico, pero conservas el 100% de tu pago como crédito para cualquier curso de Peak Network por los próximos 3 meses.</li>
                      </ul>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>


        </b-col>
        <b-col class="mb-4 align-items-center" lg="6">
          <img class="img-fluid" src="../assets/img/imgfaqs.jpeg" alt="">
        </b-col>
      </b-row>  
    </b-container>
    <b-container fluid class="footer text-center">
      <a href="https://www.facebook.com/profile.php?id=61558235153296" target="_blank"><img src="../assets/img/fb.png"></a>
      <a href="https://www.instagram.com/_peaknetwork?igsh=MXYxNTNpdWt5ZDJldg==" target="_blank"><img src="../assets/img/insta.png"></a>
      <a href="https://www.youtube.com/@Peak_Network" target="_blank"><img src="../assets/img/youtube.png"></a>
    </b-container>
    <div class="whatsapp">
          <a href="https://wa.link/f0bfcm" target="_blank">
              <img src="../assets/img/whapwhite.svg" alt="Whatsapp">
          </a>
      </div>
  </div>
</template>

<script>
import ExitIntentPopup from '@/components/ExitIntentPopup.vue'
import VueSlickCarousel from 'vue-slick-carousel'
import VueCountdown from '@chenfengyuan/vue-countdown'
import axios from 'axios'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'


export default {
  components: { 
    VueSlickCarousel,
    VueCountdown,
    ExitIntentPopup
  },
  data() {
    const now = new Date();
    const startDate = new Date('2026-03-16 18:30:00');
    return {
      nombre: '',
      email: '',
      telefono: '',
      mensaje: '',
      messageSend: '',
      pet: '',
      player: null,
      observer: null,
      userInteracted: false,
      time: startDate - now,
      slickOptions: {
        autoplay: true,
        autoplaySpeed: 10000,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        focusOnSelect: true,
        speed: 1000,
        dots: true,
        arrows: false,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: true
            }
          }
        ]
      },
    }
  },
  mounted() {
  },

  beforeDestroy() {
  },

  methods: {
    sendMessage: async function(){
        var responseData
        if(this.nombre != '' && this.email != '' && this.telefono != ''){
            await axios.post('phpmailer.php', {
                nombre: this.nombre,
                email: this.email,
                telefono: this.telefono,
                mensaje: this.mensaje
            })
            .then((response) => {
            responseData = response.data
            })
            .catch((error) => {
            /* eslint-disable no-console */
            console.log(error);
            /* eslint-enable no-console */
            });
            
            if(responseData == 200 || responseData == '200') {
                this.nombre = ''
                this.telefono = ''
                this.email = ''
                this.mensaje = ''
                this.messageSend = 'Mensaje enviado'
            } else {
                this.messageSend = 'Error al enviar mensaje, intenta mas tarde.'
            }
        } else {
            this.messageSend = 'Ingresa la información necesaria en los campos.'
        }
    },
    onPopupAccepted: async function({ email, phone , step2, step3 }) {
      // User completed all 6 steps and clicked the final button
      console.log('User accepted:', email, phone, step2, step3)
      const element = document.getElementById("compra");
      if (element) {
        element.scrollIntoView({ 
          behavior: "smooth", 
          block: "start"
        });
      }
      // Example: send data to your backend or CRM
      await axios.post('phpmailer-popup.php', 
            { email, phone }).then((response) => {
              console.log(response)
            })
            .catch((error) => {
            /* eslint-disable no-console */
            console.log(error);
            /* eslint-enable no-console */
            });

      // Example: redirect to a thank-you page or course
      // this.$router.push('/mapa-del-actor')
    },
  },
  props: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.letra {
  position: relative;
  display: inline-block;
}

.letra::after {
  content: "´";
  position: absolute;
  top: -5px;
  left: 50%;
}
h1{
  font-family: 'AkiraExpanded';
  font-size: 50px;
}
h2{
  font-family: 'AkiraExpanded';
  font-size: 50px;
}
h3{
  font-family: 'AkiraExpanded';
  font-size: 30px;
}

/* COUNTDOWN */
.countdown{
  z-index: 999;
  position: fixed;
  width: 100%;
  background: #000;
  color: #fff;
  padding-top: 35px;
  padding-bottom: 35px;
  font-family: "Inter", sans-serif;
}
.countdown p{
  margin-bottom: 0;
}
.countdown .title{
  margin-bottom: 0;
  font-family: 'NewBlackTypeface';
  font-weight: 700;
  font-size: 20px;
}
.countdown .btn{
  width: 100%;
  max-width: 180px;
  height: 40px;
  background: #2CFAC3;
  opacity: 1;
  border-radius: 20px;
  font-weight: bold;
  font-size: 20px;
  border: none;
  margin-right: 20px;
}
.countdown .count p{
  text-align: center;
  font-weight: 700;
  font-size: 15px;
}
.countdown .count p span{
  font-size: 25px;
}
.countdown .separation{
  padding-left: 10px;
  padding-right: 10px;
  color: #5864FF;
  font-weight: 700;
  font-size: 25px;
}

/* NAVBAR */
.navbar{
  background: transparent !important;
  top: 0px;
  width: 100%;
  padding: 20px 50px;
  text-align: center;
  position: relative;
}
.logopeak{
  position: absolute;
  top: 30px;
  left: 30px;

}
.logoac{
  width: 340px;
  margin-left: auto;
  margin-right: auto;
}

/* BANNER */
.banner{
  /* min-height: 100vh; */
  padding: 10% 5% 10% 5%;
  display: grid;
}
.banner .row{
  height: 100%;
}
.banner p{
  font-weight: 900;
  font-size: 35px;
}
.banner .btn{
  width: 100%;
  max-width: 550px;
  height: 51;
  padding-top: 8px;
  padding-right: 25px;
  padding-bottom: 8px;
  padding-left: 25px;
  background: #2CFAC3;
  opacity: 1;
  border-radius: 20px;
  font-family: 'NewBlackTypeface';
  font-weight: bold;
  font-size: 25px;
  border: none;
}
.banner .wapperimages {
  position: relative;
}
.banner .wapperimages .b1{
  /* position: absolute; */
  margin-top: -10%;
  width: 50%; 
  z-index: 99;
}
.banner .wapperimages .b2{
  position: absolute;
  bottom: -50%;
  left: 25%;
  width: 50%;
  z-index: -1;
}

/* SECTION1 */
.section1{
  background-color: #333333;
  /* background-image: url('../assets/img/Vector3.png'), url('../assets/img/Vector4.png');
  background-position: left top, right bottom;
  background-repeat: no-repeat, no-repeat; */
  color: #fff;
  padding: 10% 10% 0 10%;
  text-align: center;
}
.section1 .wrapper{
  max-width: 850px;
  margin: auto;
}
.section1 .subtitle1{
  font-size: 30px;
  font-weight: bold;
}.section1 .subtitle2{
  font-size: 25px;
  font-weight: 500;
}

/* VIDEO */
.sectionvideo{
  margin-top: 40px;
  margin-bottom: 100px;
  padding: 10% 18% 0 18%;
  display: grid;
  background-image: url('../assets/img/Vector5.png'), url('../assets/img/Vector6png.png');
  background-position: right top, left bottom;
  background-repeat: no-repeat, no-repeat;
}
.sectionvideo p{
  font-weight: 500;
  font-size: 25px;
}
.sectionvideo video{
  width: 100%;
  height: auto; 
  aspect-ratio: 9/16;
}
.sectionvideo .btn{
  width: 100%;
  max-width: 550px;
  height: 51;
  padding-top: 8px;
  padding-right: 25px;
  padding-bottom: 8px;
  padding-left: 25px;
  background: #2CFAC3;
  opacity: 1;
  border-radius: 20px;
  font-family: 'NewBlackTypeface';
  font-weight: bold;
  font-size: 25px;
  border: none;
}
.sectionvideo .player,
.sectionvideo iframe{
  width: 100%;
  height: auto;
  aspect-ratio: 9 / 16;
}

/* SECTION ACTORS CHALLENGE */
.section2{
  padding: 10% 7%;
  background: 
    linear-gradient(
      180deg,
      rgba(60, 60, 60, 1) 0%,
      rgba(0, 0, 0, 1) 100%
    ),
    url('../assets/img/Vector6.svg');
  background-position: right top;
  background-repeat: no-repeat, no-repeat;
  color: #fff;

}
.section2 video{
  margin-top: 70px;
  width: 100%;
  height: auto; 
  aspect-ratio: 9/16;
}
.banner .mobile,
.sectiontestimonios .mobile,
.mobile-logo{
  display: none;
}
.section2 p{
  font-size: 25px;
}
.section2 .text1{
  color: #AFAFAF;
  font-size: 25px;
}
.section2 .text1 b{
  color: #fff;
}
.section2 .text2{
  font-size: 22px;
  font-weight: 500;
}
.section2 .text3{
  font-weight: 500;
  font-size: 25px;
}
.section2 .blue-wrapper{
  text-transform: uppercase;
  font-weight: 700;
  background: #5864FF4D; 
  padding: 15px 20px; 
  border: solid 3px #5864FF; 
  border-radius: 20px
}
.section2 .green-wrapper{
  padding: 10px;
  background: #1B1B1B;
  border: 2px solid #2CFAC3;
  border-radius: 10px;
  text-align: center;
}
.green-wrapper .num{
  font-size: 30px;
}
.section2 .btn{
  width: 100%;
  max-width: 550px;
  height: 51;
  padding-top: 8px;
  padding-right: 25px;
  padding-bottom: 8px;
  padding-left: 25px;
  background: #2CFAC3;
  opacity: 1;
  border-radius: 20px;
  font-family: 'NewBlackTypeface';
  font-weight: bold;
  font-size: 25px;
  border: none;
}

/* QUE APRENDERAS */
.sectionaprenderastitle{
  display: none;
}
.sectionaprenderas{
  display: none;
  margin-top: 50px;
  margin-bottom: 50px;
  padding: 0 15%;
  background-image: url('../assets/img/Vector5.png'), url('../assets/img/Vector6png.png');
  background-position: right top, left bottom;
  background-repeat: no-repeat, no-repeat;
}
.sectionaprenderastitle h3{
  color: #5864FF;
}

.sectionaprenderas .pleca1{
  min-height: 150px;
  background-image: url('../assets/img/Pleca_Peak_Landing-1.svg');
  background-position: center;
  background-size: 100%;
  background-repeat: no-repeat;
}
.sectionaprenderas .pleca2{
  min-height: 150px;
  background-image: url('../assets/img/Pleca_Peak_Landing-2.svg');
  background-position: center;
  background-size: 100%;
  background-repeat: no-repeat;
}
.sectionaprenderas .pleca1,
.sectionaprenderas .pleca2{
  color: #fff;
  font-weight: 600;
  font-size: 30px;
  padding-left: 20%;
  padding-right: 10%;
  display: flex;
}

/* QUIENES SOMOS */
.sectionaparaquienes{
  padding: 0 7% 10% 7%;
  padding-bottom: 10%;
  background: #000000;
  color: #fff;
}
.sectionaparaquienes p.subtitle{
  font-size: 34px;
  text-transform: uppercase;
  color: #2CFAC3;
}
.sectionaparaquienes p, .sectionaparaquienes ul{
  font-size: 25px;
}
.imgpqe1{
  margin-bottom: 70px;
}
.imgpqe2{
  margin-top: 70px;
}
.sectionaparaquienes .quines-wrapper{
  background: #5864FF33;
  border: 2px solid #2CFAC3;
  border-radius: 10px;
  padding: 30px 40px;
  height: 100%;
}
.sectionaparaquienes .bullet{
  /* padding: 10px 5px 10px 50px; */
  position: relative;
  padding-left: 30px;
  /* margin-bottom: 0;
  background: #0000004D;
  border: 3px solid #fff;
  border-radius: 20px;
  margin-bottom: 20px; */
}
.sectionaparaquienes .bullet img{
  position: absolute;
  left: 0px;
  top: 3px;
}
.sectionaparaquienes .btn{
  width: 100%;
  max-width: 550px;
  height: 51;
  padding-top: 8px;
  padding-right: 25px;
  padding-bottom: 8px;
  padding-left: 25px;
  background: #2CFAC3;
  opacity: 1;
  border-radius: 20px;
  font-family: 'NewBlackTypeface';
  font-weight: bold;
  font-size: 25px;
  border: none;
}

/* TESTIMONIALES */
.sectiontestimonios{
  padding: 10% 10%;
  background-color: #333333;
  background-image: url('../assets/img/Vector7.svg');
  background-position: right top;
  background-repeat: no-repeat;
}
.sectiontestimonios .btn{
  width: 100%;
  max-width: 550px;
  height: 51;
  padding-top: 8px;
  padding-right: 25px;
  padding-bottom: 8px;
  padding-left: 25px;
  background: #2CFAC3;
  opacity: 1;
  border-radius: 20px;
  font-family: 'NewBlackTypeface';
  font-weight: bold;
  font-size: 25px;
  border: none;
}
.sectiontestimonios video{
  width: 100%;
  height: auto; 
  aspect-ratio: 9/16;
}

.testimoniowrapper{
  background: #fff;
  padding: 40px 30px;
  border-radius: 20px;
  height: 100%;
  background-image: url('../assets/img/background.png');
  background-position: center top;
  background-repeat: no-repeat, no-repeat;
}
.sectiontestimonios h3{
  color: #5864FF !important;
}
.testimoniowrapper .quote{
  font-size: 25px;
} 
.testimoniowrapper .name{
  font-size: 25px;
  font-weight: bold;
}
.testimoniowrapper .user{
  font-size: 25px;
  font-weight: bold;
  text-decoration: none;
  color: #000;
}

/* CURSO */
.sectioncurso{
  margin-top: 10%;
  padding: 0 7% 0 7%;
  background-image: url('../assets/img/Vector7.svg'), url('../assets/img/Vector3.png');
  background-position: right top, left 10%;
  background-repeat: no-repeat, no-repeat;
}
.wrappercurso-purple{
  border-radius: 20px;
  border: 2px solid #5864FF;
  -webkit-box-shadow: 10px 5px 0px 5px #5864FF; 
  box-shadow: 10px 5px 0px 5px #5864FF;
}
.wrappercurso-black{
  border-radius: 20px;
  border: 2px solid #000;
  -webkit-box-shadow: 10px 5px 0px 5px #000; 
  box-shadow: 10px 5px 0px 5px #000;
}
.wrappercurso-purple,
.wrappercurso-black{
  padding: 40px 30px;
  background: #fff;
}
.sectioncurso .titleday{
  font-weight: 600;
  font-size: 30px;
  font-family: 'NewBlackTypeface';
}
.sectioncurso ul {
  padding-inline-start: 15px;
  font-size: 22px;
}
.sectioncurso .btn{
  width: 100%;
  max-width: 550px;
  height: 51;
  padding-top: 8px;
  padding-right: 25px;
  padding-bottom: 8px;
  padding-left: 25px;
  background: #2CFAC3;
  opacity: 1;
  border-radius: 20px;
  font-family: 'NewBlackTypeface';
  font-weight: bold;
  font-size: 25px;
  border: none;
}

/* EXPERTOS */
.sectioninvitados{
  padding: 10% 7%;
  color: #fff;
  font-size: 22px;
  background-color: #333333;
  background-image: url('../assets/img/Vector6.svg'), url('../assets/img/Vector6png.png'), url('../assets/img/Vector8.svg');
  background-position: right top, left 45%, right 75%;
  background-repeat: no-repeat, no-repeat, no-repeat;
}
.sectioninvitados h2{
  color: #2CFAC3;
}
.sectioninvitados .img-face{
  max-width: 285px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.sectioninvitados .img-name{
  max-width: 420px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.sectioninvitados .img-handle{
  display: block;
  width: fit-content;
  text-align: center;
  max-height: 30px;
  margin-left: auto;
  margin-right: auto;
}
.sectioninvitados a{
  color: #2CFAC3;
  display: inline-flex;
  text-decoration: none;
}

/* ACCESOS */
.sectionaccesos{
  padding: 5% 12% 50px 12%;
  font-size: 25px;
}
.table{
  border: 2px solid #2CFAC3;
  font-size: 15px;
  -webkit-box-shadow: 10px 5px 0px 5px #2CFAC3; 
  box-shadow: 10px 5px 0px 5px #2CFAC3;
  border-radius: 20px ! important;
  border-collapse: separate;
  border-spacing: 0;
}
.table td{
  border-top: 3px solid #5864FF;
}
.table thead th{
  font-size: 20px;
  border: none;
}
.table label{
  font-weight: 900;
  font-size: 30px;
  color: #5864FF;
}

/* CARDS BUY */
.sectioncompras{
  padding: 0 12% 50px 12%;
}
.sectioncompras .btn{
  width: 100%;
  max-width: 550px;
  height: 51;
  padding-top: 8px;
  padding-right: 25px;
  padding-bottom: 8px;
  padding-left: 25px;
  background: #2CFAC3;
  opacity: 1;
  border-radius: 20px;
  font-family: 'NewBlackTypeface';
  font-weight: bold;
  font-size: 25px;
  border: none;
}
.cardbuy{
  position: relative;
  border-radius: 20px;
  height: 100%;
  padding: 40px 20px;
}
.cardbuy .btn{
  background: #000;
  color: #fff;
  width: 100%;
  font-size: 18px;
  border-radius: 50px;
}
.cardbuy .pleca-desc{
  position: absolute;
  width: 80px;
  right: 0;
  top: 0;
}
.cardbuy .title{
  font-weight: bold;
  font-size: 22px;
}
.cardbuy .nameplan{
  font-size: 15px;
  color: #676767;
}
.cardbuy .price{
  font-size: 25px;
  font-weight: 500;
}
.cardbuy hr {
    margin-bottom: 0;
}
.welcome .inner{
  background: #E2E5FF;
  border-radius: 20px;
  padding: 20px;
  margin-bottom: 20px;
  min-height: 180px;
}
.pro .inner{
  background: #D6FFF5;
  border-radius: 20px;
  padding: 20px;
  margin-bottom: 20px;
  min-height: 180px;
}
.peaker .inner{
  background: #DADDFF;
  border-radius: 20px;
  padding: 20px;
  margin-bottom: 20px;
  min-height: 180px;
}
.cardbuy .bullets{
  position: relative;
  padding-left: 20px;
  margin-bottom: 0;
}
.cardbuy .bullets img{
  position: absolute;
  left: 0;
  top: 5px;
}
.welcome{
  background: #EEF0FF;
}
.pro{
  background: #EEFFFB;
}
.peaker{
  background: #868FFF33;
}
.wrapperdate{
  background: #EDEDED;
  font-size: 25px;
  font-weight: 900;
  max-width: 550px;
  border-radius: 50px;
  margin-left: auto;
  margin-right: auto;
}


/* FAQ */
.sectionfaq{
  padding: 7% 5% 3% 5%;
  color: #fff;
  font-size: 25px;
  background: #333333;
}
.sectionfaq .card{
  background: transparent !important;
  padding-left: 0;
  border: none;
}
.card-body{
  padding-left: 0;
}
.sectionfaq .btn{
  text-align: left;
  padding-left: 0;
  border: none;
  font-size: 25px;
  font-weight: bold;
  background: transparent !important;
}
.card-header{
  border-bottom: 2px solid #fff;
  background: transparent !important;
}
/* CONTACTO */
.sectioncontacto{
  padding: 7% 7% 3% 7%;
  background: #000;
  color: #FFF;
}
.sectioncontacto h4{
  color: #fff;
  font-family: 'AkiraExpanded';
}
.sectioncontacto .btn{
  background: #5864FF;
  width: 100%;
  border: none;
  border-radius: 10px;
  height: 60px;
}

.form-floating {
  position: relative;
}
.form-control{
  background: transparent !important;
  color: #fff !important;
  border-radius: 10px;
}

.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: var(--form-floating-height);
  min-height: var(--form-floating-height);
  line-height: var(--form-floating-line-height);
}

.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  max-width: 100%;
  height: 100%;
  padding: var(--form-floating-padding-y) var(--form-floating-padding-x);
  overflow: hidden;
  color: #fff;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: var(--input-border-width) solid transparent;
  transform-origin: 0 0;
  transition: var(--form-floating-transition);
}

.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: var(--form-floating-padding-y) var(--form-floating-padding-x);
}

.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}

.form-floating > .form-control:focus,
.form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: var(--form-floating-input-padding-t);
  padding-bottom: var(--form-floating-input-padding-b);
}

.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: var(--form-floating-input-padding-t);
  padding-bottom: var(--form-floating-input-padding-b);
}

.form-floating > .form-select {
  padding-top: var(--form-floating-input-padding-t);
  padding-bottom: var(--form-floating-input-padding-b);
  padding-left: var(--form-floating-padding-x);
}

.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  transform: var(--form-floating-label-transform);
}

.form-floating > .form-control:-webkit-autofill ~ label {
  transform: var(--form-floating-label-transform);
}

.form-floating > textarea:focus ~ label::after,
.form-floating > textarea:not(:placeholder-shown) ~ label::after {
  position: absolute;
  inset: var(--form-floating-padding-y) calc(var(--form-floating-padding-x) * 0.5);
  z-index: -1;
  height: var(--form-floating-label-height);
  content: "";
  background-color: transparent !important;
  border-radius: var(--input-border-radius);
}

.form-floating > textarea:disabled ~ label::after {
  background-color: var(--input-disabled-bg);
}

.form-floating > .form-control-plaintext ~ label {
  border-width: var(--input-border-width) 0;
}

.form-floating > :disabled ~ label,
.form-floating > .form-control:disabled ~ label {
  color: var(--form-floating-label-disabled-color);
}
.pet-field{
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    height: 0;
    width: 0;
    z-index: -1;
}
input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-internal-autofill-selected {
    -webkit-box-shadow: 0 0 50px rgba(255, 255, 255, 0) inset !important;
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0), inset 0 0 0 100px rgba(255, 255, 255,1);
    background-color: transparent !important;
    background-clip: text;
    transition: background-color 0s 600000s, color 0s 600000s !important;
}



/* FOOTER */
.footer{
  padding: 15px;
  background: #333333;
}
.footer a{
  margin-left: 10px;
  margin-right: 10px;
}
.btn-collapse{
  padding-right: 30px;
  position: relative;
}
.btn-collapse img{
  position: absolute;
  right: 0;
  bottom: 20px;
}
.btn-collapse.not-collapsed img{
  transform: rotateX(180deg);
}

@media (max-width: 992px) {
  h1{
    font-size: 46px;
  }
  h2{
    font-size: 46px;
  }
  h3{
    font-size: 28px;
  }
  /* COUNTDOWN */
  .countdown{
    width: 100%;
    padding-top: 30px;
    padding-bottom: 30px;
  }
  .countdown .title{
    margin-bottom: 0;
    font-weight: 700;
    font-size: 18px;
  }
  .countdown .btn{
    width: 100%;
    max-width: 140px;
    height: 40px;
    background: #2CFAC3;
    opacity: 1;
    border-radius: 20px;
    font-weight: bold;
    font-size: 18px;
    border: none;
    margin-right: 10px;
  }
  .countdown .count p{
    text-align: center;
    font-weight: 700;
    font-size: 15px;
  }
  .countdown .count p span{
    font-size: 20px;
  }
  .countdown .separation{
    padding-left: 0px;
    padding-right: 0px;
    color: #5864FF;
    font-weight: 700;
    font-size: 20px;
  }
  /* NAVBAR */
  .navbar{
    display: block;
  }
  /* BANNER */
  .banner{
    padding: 200px 5% 10% 5%;
  }
  .banner .btn{
    width: 100%;
    max-width: 550px;
    height: 51;
    padding-top: 8px;
    padding-right: 25px;
    padding-bottom: 8px;
    padding-left: 23px;
    background: #2CFAC3;
    opacity: 1;
    border-radius: 20px;
    font-family: 'NewBlackTypeface';
    font-weight: bold;
    font-size: 25px;
    border: none;
  }
  .banner .wapperimages {
    position: relative;
  }
  .banner .wapperimages .b1{
    margin-top: 10px;
    z-index: 99;
  }
  .banner .wapperimages .b2{
    position: absolute;
    bottom: -20%;
    left: 30%;
  }
  /* SECTION1 */
  .section1{
    padding: 10% 20%;
  }
  .section1 .subtitle1{
    font-size: 27px;
    font-weight: bold;
  }
  .section1 .subtitle2{
    font-size: 23px;
    font-weight: 500;
  }
  /* VIDEO */
  .sectionvideo p{
    font-weight: 500;
    font-size: 23px;
  }
  .sectionvideo .btn{
    width: 100%;
    max-width: 550px;
    height: 51;
    padding-top: 8px;
    padding-right: 25px;
    padding-bottom: 8px;
    padding-left: 23px;
    background: #2CFAC3;
    opacity: 1;
    border-radius: 20px;
    font-family: 'NewBlackTypeface';
    font-weight: bold;
    font-size: 25px;
    border: none;
  }
  /* SECTION ACTORS CHALLENGE */
  .section2{
    padding: 10% 10%;
  }
  .section2 p{
    font-size: 23px;
  }
  .section2 video{
      margin-top: 00px;
      width: 100%;
      height: auto; 
      aspect-ratio: 9/16;
    }
  .section2 .text1{
    font-weight: 900;
    font-size: 23px;
  }
  .section2 .text2{
    font-weight: 600;
    font-size: 23px;
  }
  .section2 .text3{
    font-weight: 500;
    font-size: 23px;
  }
  .section2 .btn{
    width: 100%;
    max-width: 550px;
    height: 51;
    padding-top: 8px;
    padding-right: 25px;
    padding-bottom: 8px;
    padding-left: 23px;
    background: #2CFAC3;
    opacity: 1;
    border-radius: 20px;
    font-family: 'NewBlackTypeface';
    font-weight: bold;
    font-size: 25px;
    border: none;
  }

  /* QUE APRENDERAS */
  .sectionaprenderas{
    margin-top: 50px;
    margin-bottom: 50px;
    padding: 0 15%;
  }
  .sectionaprenderas .pleca1{
    min-height: 150px;
  }
  .sectionaprenderas .pleca2{
    min-height: 150px;
  }
  .sectionaprenderas .pleca1,
  .sectionaprenderas .pleca2{
    font-size: 28px;
    padding-left: 20%;
    padding-right: 10%;
    display: flex;
  }

  /* QUIENES SOMOS */
  .sectionaparaquienes{
    padding: 10% 7%;
    padding-bottom: 10%;
    color: #fff;
  }
  .sectionaparaquienes h3{
    font-size: medium;
    text-align: left;
  }
  .sectionaparaquienes p, .sectionaparaquienes ul{
    font-size: 28px;
  }

  /* TESTIMONIALES */
  .sectiontestimonios{
    padding: 10% 5%;
    background-color: #333333;
    background-image: url('../assets/img/Vector7.svg');
    background-position: right top;
    background-repeat: no-repeat;

  }

  .testimoniowrapper{
    background: #fff;
    padding: 40px 30px;
    border-radius: 20px;
    height: 100%;
    background-image: url('../assets/img/background.png');
    background-position: center top;
    background-repeat: no-repeat, no-repeat;
  }
  .testimoniowrapper .quote{
    font-size: 23px;
  } 
  .testimoniowrapper .name{
    font-size: 23px;
    font-weight: bold;
  }
  .testimoniowrapper .user{
    font-size: 23px;
    font-weight: bold;
    text-decoration: none;
    color: #000;
  }

  /* CURSO */
  .sectioncurso{
    margin-top: 10%;
    padding: 0 7% 0 7%;
    background-image: url('../assets/img/Vector7.svg'), url('../assets/img/Vector3.png');
    background-position: right top, left 10%;
    background-repeat: no-repeat, no-repeat;
  }
  .sectioncurso .btn{
    width: 100%;
    max-width: 550px;
    height: 51;
    padding-top: 8px;
    padding-right: 25px;
    padding-bottom: 8px;
    padding-left: 23px;
    background: #2CFAC3;
    opacity: 1;
    border-radius: 20px;
    font-family: 'NewBlackTypeface';
    font-weight: bold;
    font-size: 25px;
    border: none;
  }
  .wrappercurso-purple,
  .wrappercurso-black{
    padding: 40px 30px;
  }
  .sectioncurso .titleday{
    font-weight: 600;
    font-size: 28px;
    font-family: 'NewBlackTypeface';
  }
  .sectioncurso ul {
    padding-inline-start: 15px;
    font-size: 20px;
  }

  /* EXPERTOS */
  .sectioninvitados{
    padding: 10% 7%;
    color: #fff;
    font-size: 22px;
    background-color: #333333;
    background-image: url('../assets/img/Vector6.svg'), url('../assets/img/Vector6png.png'), url('../assets/img/Vector8.svg');
    background-position: right top, left 45%, right 75%;
    background-repeat: no-repeat, no-repeat, no-repeat;
  }
  .sectioninvitados h2{
    color: #2CFAC3;
  }
  .sectioninvitados .img-face{
    max-width: 285px;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  .sectioninvitados .img-name{
    max-width: 420px;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  .sectioninvitados .img-handle{
    display: block;
    width: fit-content;
    text-align: center;
    max-height: 30px;
    margin-left: auto;
    margin-right: auto;
  }

  /* ACCESOS */
  .sectionaccesos{
    padding: 10% 12% 50px 12%;
    font-size: 25px;
  }
  .table{
    border: 2px solid #2CFAC3;
    font-size: 15px;
    -webkit-box-shadow: 10px 5px 0px 5px #2CFAC3; 
    box-shadow: 10px 5px 0px 5px #2CFAC3;
    border-radius: 20px ! important;
    border-collapse: separate;
    border-spacing: 0;
  }
  .table td{
    border-top: 3px solid #5864FF;
  }
  .table thead th{
    font-size: 20px;
    border: none;
  }
  .table label{
    font-weight: 900;
    font-size: 30px;
    color: #5864FF;
  }

  /* CARDS BUY */
  .sectioncompras{
    padding: 0 12% 50px 12%;
  }
  .cardbuy{
    border-radius: 20px;
    height: 100%;
    padding: 40px 20px;
  }
  .cardbuy .btn{
    background: #000;
    color: #fff;
    width: 100%;
    font-size: 18px;
    border-radius: 50px;
  }
  .cardbuy .title{
    font-weight: bold;
    font-size: 22px;
  }
  .cardbuy .nameplan{
    font-size: 15px;
    color: #676767;
  }
  .cardbuy .price{
    font-size: 47px;
    font-weight: 500;
  }
  .cardbuy hr {
      margin-bottom: 0;
  }
  .welcome .inner{
    background: #E2E5FF;
    border-radius: 20px;
    padding: 20px;
    margin-bottom: 20px;
    min-height: 180px;
  }
  .pro .inner{
    background: #D6FFF5;
    border-radius: 20px;
    padding: 20px;
    margin-bottom: 20px;
    min-height: 180px;
  }
  .peaker .inner{
    background: #DADDFF;
    border-radius: 20px;
    padding: 20px;
    margin-bottom: 20px;
    min-height: 180px;
  }
  .cardbuy .bullets{
    position: relative;
    padding-left: 20px;
    margin-bottom: 0;
  }
  .cardbuy .bullets img{
    position: absolute;
    left: 0;
    top: 5px;
  }
  .welcome{
    background: #EEF0FF;
  }
  .pro{
    background: #EEFFFB;
  }
  .peaker{
    background: #868FFF33;
  }
  .wrapperdate{
    background: #EDEDED;
    font-size: 25px;
    font-weight: 900;
    max-width: 550px;
    border-radius: 50px;
    margin-left: auto;
    margin-right: auto;
  }

  /* FAQ */
  .sectionfaq{
    padding: 7% 5% 3% 5%;
    color: #fff;
    font-size: 20px;
    background: #333333;
  }
  
  .sectionfaq .btn{
    text-align: left;
    padding-left: 0;
    border: none;
    font-size: 23px;
    font-weight: bold;
    background: transparent !important;
  }
  .card-header{
    border-bottom: 1.5px solid #fff;
  }

}

@media (max-width: 768px) {
  h1{
    font-size: 31px;
  }
  h2{
    font-size: 30px;
  }
  h3{
    font-size: 25px;
  }
  /* COUNTDOWN */
  .countdown{
    width: 100%;
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .countdown .title{
    margin-bottom: 0;
    font-weight: 700;
    font-size: 18px;
    text-align: center;
  }
  .countdown .btn{
    width: 100%;
    max-width: 140px;
    height: 40px;
    background: #2CFAC3;
    opacity: 1;
    border-radius: 20px;
    font-weight: bold;
    font-size: 18px;
    border: none;
    margin-right: 10px;
    margin-left: auto;
  }
  .countdown .count>span{
    margin-right: auto;
  }
  .countdown .count p{
    text-align: center;
    font-weight: 700;
    font-size: 15px;
  }
  .countdown .count p span{
    font-size: 20px;
  }
  .countdown .separation{
    padding-left: 10px;
    padding-right: 10px;
    color: #5864FF;
    font-weight: 700;
    font-size: 20px;
  }
  /* NAVBAR */
  .navbar{
    padding-top: 20px;
    text-align: left;
    display: block;
    padding-left: 20px;
    padding-right: 20px;
  }
  .navbar img{
    max-width: 30%;
    min-width: 160px;
  }
  .logopeak{
    display: none;
  }
  .logoac{
    margin-left: 0;
  }
  /* BANNER */
  .banner{
    padding: 70px 20px 0px 20px;
  }
  .section2 .btn,
.sectionaparaquienes .btn,
.sectiontestimonios .btn,
.sectioncurso .btn,
.sectioncompras .btn,
  .banner .btn{
    width: 100%;
    max-width: 550px;
    height: 51;
    padding-top: 8px;
    padding-right: 10px;
    padding-bottom: 8px;
    padding-left: 10px;
    background: #2CFAC3;
    opacity: 1;
    border-radius: 20px;
    font-family: 'NewBlackTypeface';
    font-weight: bold;
    font-size: 16px;
    border: none;
  }
  .banner p{
    line-height: 1;
    max-width: 300px;
    font-size: 33px;
  }
  .banner .wapperimages {
    display: none;
  }
  /* SECTION1 */
  .section1{
    padding: 90px 30px;
    background-size: 60px, 60px;
  }
  .section1 .subtitle1{
    font-size: 20px;
    font-weight: bold;
  }
  .section1 .subtitle2{
    font-size: 20px;
    font-weight: 500;
  }
  /* VIDEO */
  .sectionvideo{
    margin-top: 0;
    padding: 10px 30px 60px 30px;
    background-position: right top, left 60%;
    background-size: 100px, 100px;
    margin-bottom: 0;
    text-align: center;
  }
  .sectionvideo h3{
    display: none;
  }
  .sectionvideo p{
    font-weight: 500;
    font-size: 20px;
    display: none;
  }
  .sectionvideo .btn{
    width: 100%;
    margin-top: 50px;
    max-width: 550px;
    height: 51;
    padding-top: 8px;
    padding-right: 25px;
    padding-bottom: 8px;
    padding-left: 20px;
    background: #2CFAC3;
    opacity: 1;
    border-radius: 20px;
    font-family: 'NewBlackTypeface';
    font-weight: bold;
    font-size: 22px;
    border: none;
    margin-left: auto;
    margin-right: auto;
  }
  /* SECTION ACTORS CHALLENGE */
  .section2{
    padding: 50px 30px;
  }
  .section2 p{
    font-size: 16px;
  }
  .section2 .text1{
    font-weight: 900;
    font-size: 16px;
  }
  .banner .mobile,
  .sectiontestimonios .mobile,
  .mobile-logo{
    display: block;
  }
  .mobile-logo{
    width: 50%;
  }
  .sectionvideo .desktop,
  .sectiontestimonios .desktop,
  .desktop-logo{
    display: none;
  }
  .section2 .text2{
    font-weight: 600;
    font-size: 16px;
  }
  .section2 .text3{
    font-weight: 500;
    font-size: 16px;
  }

  .green-wrapper span{
    font-size: 12px;
  }
  .green-wrapper.day {
    text-align: left;
  }
  .section2 .btn{
    width: 100%;
    max-width: 550px;
    height: 51;
    padding-top: 8px;
    padding-right: 25px;
    padding-bottom: 8px;
    padding-left: 20px;
    background: #2CFAC3;
    opacity: 1;
    border-radius: 20px;
    font-family: 'NewBlackTypeface';
    font-weight: bold;
    font-size: 22px;
    border: none;
  }

  /* QUE APRENDERAS */
  .sectionaprenderas{
    margin-top: 35px;
    margin-bottom: 50px;
    padding: 0 30px;
    background-position: 120% top, -25% bottom;
    background-size: 100px, 100px;
  }
  .sectionaprenderas .pleca1{
    min-height: 60px;
  }
  .sectionaprenderas .pleca2{ 
    min-height: 80px;
  }
  .sectionaprenderas .pleca1,
  .sectionaprenderas .pleca2{
    font-size: 18px;
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 20%;
    padding-right: 10%;
    display: flex;
  }

  /* QUIENES SOMOS */
  .sectionaparaquienes{
    padding: 50px 30px;
    padding-bottom: 10%;
    color: #fff;
  }
  .sectionaparaquienes h3{
    text-align: left;
  }
  .sectionaparaquienes p, .sectionaparaquienes ul{
    font-size: 20px;
  }
  .imgpqe1{
    margin-bottom: 10px;
  }
  .imgpqe2{
    display: none;
    margin-top: 10px;
  }
  .sectionaparaquienes p.subtitle{
    font-size: 20px;
  }
  .sectionaparaquienes p, .sectionaparaquienes ul{
    font-size: 18px;
  }

.sectionaparaquienes .quines-wrapper{
  background: #5864FF33;
  border: 2px solid #2CFAC3;
  border-radius: 10px;
  padding: 30px 40px;
  height: 100%;
}
.sectionaparaquienes .bullet{
  position: relative;
  padding-left: 30px;
}
.sectionaparaquienes .bullet img{
  position: absolute;
  left: 0px;
  top: 3px;
}

  /* TESTIMONIALES */
  .sectiontestimonios{
    padding: 0px 30px 70px 30px;
    background-color: #333333;
    background-image: none;

  }

  .testimoniowrapper{
    background: #fff;
    padding: 40px 30px;
    border-radius: 20px;
    height: 100%;
    background-image: url('../assets/img/background.png');
    background-position: center top;
    background-repeat: no-repeat, no-repeat;
  }
  .testimoniowrapper .quote{
    font-size: 20px;
  } 
  .testimoniowrapper .name{
    font-size: 20px;
    font-weight: bold;
  }
  .testimoniowrapper .user{
    font-size: 20px;
    font-weight: bold;
    text-decoration: none;
    color: #000;
  }

  /* CURSO */
  .sectioncurso{
    margin-top: 0;
    padding: 50px 30px 0 30px;
    background-image: none;
  }
  .wrappercurso-purple,
  .wrappercurso-black{
    padding: 40px 30px;
  }
  .sectioncurso .titleday{
    font-weight: 600;
    font-size: 25px;
    font-family: 'NewBlackTypeface';
  }
  .sectioncurso ul {
    padding-inline-start: 15px;
    font-size: 20px;
  }

  /* EXPERTOS */
  .sectioninvitados{
    padding: 50px 30px;
    color: #fff;
    font-size: 18px;
    background-color: #333333;
    background-image: none;
  }
  .sectioninvitados h2{
    color: #2CFAC3;
  }
  .sectioninvitados .img-face{
    max-width: 70%;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  .sectioninvitados .img-name{
    max-width: 100%;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  .sectioninvitados .img-handle{
    display: block;
    width: fit-content;
    text-align: center;
    max-height: 30px;
    margin-left: auto;
    margin-right: auto;
  }

  /* ACCESOS */
  .sectionaccesos{
    padding: 50px 20px;
    font-size: 20px;
  }
  .table{
    max-width: 100% !important;
    border: 2px solid #2CFAC3;
    font-size: 12px;
    -webkit-box-shadow: 10px 5px 0px 5px #2CFAC3; 
    box-shadow: 10px 5px 0px 5px #2CFAC3;
    border-radius: 20px ! important;
    border-collapse: separate;
    border-spacing: 0;
  }
  .mobile-cell{
    display: none;
  }
  .table td{
    border-top: 3px solid #5864FF;
  }
  .table th, .table td{
    padding: 5px;
  }
  .table thead th{
    font-size: 14px;
    border: none;
  }
  .table label{
    font-weight: 900;
    font-size: 20px;
    color: #5864FF;
  }

  /* CARDS BUY */
  .sectioncompras{
    padding: 0 30px 50px 30px;
  }
  .cardbuy{
    border-radius: 20px;
    height: 100%;
    padding: 40px 20px;
  }
  .cardbuy .btn{
    background: #000;
    color: #fff;
    width: 100%;
    font-size: 18px;
    border-radius: 50px;
  }
  .cardbuy .title{
    font-weight: bold;
    font-size: 22px;
  }
  .cardbuy .nameplan{
    font-size: 15px;
    color: #676767;
  }
  .cardbuy .price{
    font-size: 30px;
    font-weight: 500;
  }
  .cardbuy hr {
      margin-bottom: 0;
  }
  .welcome .inner{
    background: #E2E5FF;
    border-radius: 20px;
    padding: 20px;
    margin-bottom: 20px;
    min-height: 10px;
  }
  .pro .inner{
    background: #D6FFF5;
    border-radius: 20px;
    padding: 20px;
    margin-bottom: 20px;
    min-height: 10px;
  }
  .peaker .inner{
    background: #DADDFF;
    border-radius: 20px;
    padding: 20px;
    margin-bottom: 20px;
    min-height: 10px;
  }
  .cardbuy .bullets{
    position: relative;
    padding-left: 20px;
    margin-bottom: 0;
  }
  .cardbuy .bullets img{
    position: absolute;
    left: 0;
    top: 5px;
  }
  .welcome{
    background: #EEF0FF;
  }
  .pro{
    background: #EEFFFB;
  }
  .peaker{
    background: #868FFF33;
  }
  .wrapperdate{
    background: #EDEDED;
    font-size: 25px;
    padding: 5px 10px;
    font-weight: 900;
    max-width: 550px;
    border-radius: 50px;
    margin-left: auto;
    margin-right: auto;
  }

  /* FAQ */
  .sectionfaq{
    padding: 50px 30px 20px 30px;
    color: #fff;
    font-size: 18px;
    background: #333333;
  }
  
  .sectionfaq .btn{
    text-align: left;
    padding-left: 0;
    border: none;
    font-size: 18px;
    font-weight: bold;
    background: transparent !important;
  }
  .card-header{
    border-bottom: 1.5px solid #fff;
  }
  .sectionfaq .img{
    display: none;
  }

  /* CONTACTO */
  .sectioncontacto{
    padding: 50px 7% 3% 7%;
    background: #000;
    color: #FFF;
  }
  .sectioncontacto img{
    max-width: 250px;
  }
}
@media (max-width: 550px) {
/* COUNTDOWN */
.countdown{
    width: 100%;
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .countdown .title{
    margin-bottom: 0;
    font-weight: 700;
    font-size: 12px;
    text-align: center;
    margin-bottom: 20px;
  }
  .countdown .btn{
    width: 100%;
    max-width: 105px;
    height: 30px;
    background: #2CFAC3;
    opacity: 1;
    border-radius: 20px;
    font-weight: bold;
    font-size: 12px;
    border: none;
    margin-right: 10px;
  }
  .countdown .count p{
    text-align: center;
    font-weight: 700;
    font-size: 12px;
  }
  .countdown .count p span{
    font-size: 20px;
  }
  .countdown .separation{
    padding-left: 5px;
    padding-right: 5px;
    color: #5864FF;
    font-weight: 700;
    font-size: 20px;
  }
}
@media (max-width: 460px) {
  .cardbuy .price{
    font-size: 37px;
    font-weight: 500;
  }
}
@media (max-width: 396px) {
  .cardbuy .price{
    font-size: 33px;
    font-weight: 500;
  }
}
@media (max-width: 371px) {
  .sectionaprenderas .pleca1, .sectionaprenderas .pleca2{
    font-size: 16px;
  }
  .cardbuy .price{
    font-size: 31px;
    font-weight: 500;
  }
}
/* -------------  WHATSAPP ------------- */
.whatsapp{
    position: fixed;
    bottom: 10px;
    right: 20px;
    width: 60px !important;
}
.wrapper-whatsapp{
  background: #fff;
  padding: 10px 20px;
  top: -75px;
  left: -150px;
  text-align: center;
  width: 220px;
  position: absolute;
  border-radius: 20px;
  -webkit-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.5); 
  box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.5);
}
.wrapper-whatsapp a{
  text-decoration: none;
  color: #000;
}
.whatsapp img{
    width: 100%;
}



</style>
